<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="household_number">Household Number</label>
                <input type="text" v-model="search_data.household_number"
                  id="household_number" name="household_number"
                  placeholder="Search by HH No"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="name">Household Head Name</label>
                <input type="text" v-model="search_data.name"
                  id="name" name="name"
                  placeholder="Search by Name"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="c_village_id">Village</label>
                <select
                  v-model="search_data.c_village_id"
                  id="c_village_id"
                  name="c_village_id"
                  class="form-control form-control-sm"
                >
                  <option selected :value="''">Select a village</option>
                  <option
                    v-for="(village, index) in villages"
                    :key="index"
                    :value="village.id"
                    >{{ village.id }} : {{ village.desc }}</option
                  >
                </select>
              </div>
            </div>
            <button class="btn btn-success btn-sm mt-2" @click.prevent="search">
              Search
            </button>
          </form>
        </b-card>

        <b-card>
          <b-dropdown v-if="trainees.total > 0"  class="float-left mb-1" variant="default" style=" background-color: #d4d4d4; border-color: #8c8c8c;">
            <template v-slot:button-content>
              <i class="fa fa-cog"></i>
            </template>
            <b-dropdown-form style="width: 207px !important; overflow-y: auto">
              <span v-for="(checkboxArray, index) in checkboxArrays" :key="index" class="ml-3">
                <input type="checkbox" v-model="selected" :value="checkboxArray" :id="checkboxArray">&nbsp;{{ checkboxArray }} <br>
              </span>
            </b-dropdown-form>
          </b-dropdown>
          <div class="row mb-2">
            <div class="col-sm-12">
              <div v-if="flag">
                <span class="badge badge-success">Total Search Data Found: {{ trainees.total }}</span>
                <download-excel
                        class = "btn btn-light float-right"
                        :fetch = "fetchData"
                        :fields = "trainee_fields"
                        :meta="json_meta"
                        worksheet = "Trainee"
                        name = "trainee.xls">
                  Download Excel
                </download-excel>
              </div>
            </div>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th v-if="isVisible('Household Number')">Household Number</th>
                <th v-if="isVisible('Name')">Name</th>
                <th v-if="isVisible('Father Name')">Father Name</th>
                <th v-if="isVisible('Mother Name')">Mother Name</th>
                <th v-if="isVisible('Village')">Village</th>
                <th v-if="isVisible('Mouza')">Mouza</th>
                <th v-if="isVisible('Representative')">Representative</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(trainee, index) in trainees.data" :key="trainee.id">
                <td>{{ trainees.from + index }}</td>
                <td v-if="isVisible('Household Number')">{{ trainee.household_number }}</td>
                <td v-if="isVisible('Name')">
                  <span v-if="trainee.rep_name !== null">
                       <router-link :to="{
                            name: 'traineeView',
                            params: { trainee_id: trainee.id }}" tag="a" target="_blank">

                      <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                          <span v-if="image.file_tag === '2'">
                            <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                          </span>
                      </span>
                    {{ trainee.name }}
                  </router-link>
                  </span>
                  <span v-else>
                       <router-link :to="{
                            name: 'traineeView',
                            params: { trainee_id: trainee.id }}" tag="a" target="_blank">

                      <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                          <span v-if="image.file_tag === '1'">
                            <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                          </span>
                      </span>
                    {{ trainee.name }}
                  </router-link>
                  </span>
                </td>
                <td v-if="isVisible('Father Name')">
                  <span v-if="trainee.rep_father_husband_name !== null">
                    {{ trainee.rep_father_husband_name }}
                  </span>
                  <span v-else>
                      {{ trainee.father_husband_name }}
                  </span>
                </td>
                <td v-if="isVisible('Mother Name')">
                   <span v-if="trainee.rep_mother_name !== null">
                    {{ trainee.rep_mother_name }}
                  </span>
                  <span v-else>
                      {{ trainee.mother_name }}
                  </span>
                </td>
                <td v-if="isVisible('Village')">{{ trainee.village.desc }}</td>
                <td v-if="isVisible('Mouza')">{{ trainee.mouza.desc }}</td>
                <td v-if="isVisible('Representative')">
                  <span v-if="trainee.is_representative === 0">
                    No
                  </span>
                  <span v-else>
                     Yes
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <h5 v-if="!flag" class="text-center text-secondary">
            No Data Found
          </h5>
          <div class="float-right">
            <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Create Trainee",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, PageHeader },
  data() {
    return {
      title: "Search Trainee",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Trainee",
          active: true
        }
      ],
      trainees: {},
      search_data: {
        household_number: '',
        name: '',
        c_village_id: ''
      },
      villages: [],
      trainee: "",
      trainee_fields: {
        'Household Number': 'household_number',
        'Field Book': 'field_book_sl',
        'Name': {
          callback: (value) => {
            return `${value.rep_name ? value.rep_name : value.name}`;
          }
        },
        'NID': {
          callback: (value) => {
            return `${value.rep_nid ? value.rep_nid : value.nid}`;
          }
        },
        'Fathers Name': {
          callback: (value) => {
            return `${value.rep_father_husband_name ? value.rep_father_husband_name : value.father_husband_name}`;
          }
        },
        'Mothers Name': {
          callback: (value) => {
            return `${value.rep_mother_name ? value.rep_mother_name : value.mother_name}`;
          }
        },
        'Village': 'village.desc',
        'Mouza': 'mouza.desc',
        'Representative': {
          callback: (value) => {
            if (value.is_representative === 0){
              return `No`
            }else{
              return `Yes`
            }
          }
        },
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      search_query: "",
      flag: false,
      checkboxArrays: ['Household Number', 'Name', 'Representative', 'Father Name', 'Mother Name', 'Village', 'Mouza'],
      selected: ['Household Number', 'Name', 'Representative', 'Father Name', 'Mother Name', 'Village', 'Mouza'],

    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/ses/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.villages = data.villages;
        }
      });
    },
    search() {
      http.post("api/batch/trainees/search", this.search_data).then(response => {
        if (!response.error) {
          this.flag = true;
          this.trainees = response.data.trainees;
        }
      });
    },
    getResults(page = 1) {
      http.post('api/batch/trainees/search?page=' + page, this.search_data)
              .then(response => {
                this.flag = true;
                this.trainees = response.data.trainees;
              });
    },
    async fetchData(){
      const response = await http.post("api/batch/trainees/download_trainees", this.search_data);
      return response.data.trainees;
    },
    isVisible(row) {
      const matchedValue = this.checkboxArrays.find(
              v => row === v
      );

      if (!matchedValue) {
        return true;
      }
      return this.selected.includes(matchedValue);
    }
  },

  // computed:{
  //     filteredTrainee: function () {
  //         return this.trainees.data.filter((trainee) => {
  //           return trainee.name.toLocaleLowerCase().match(this.search_query.toLocaleLowerCase());
  //         })
  //     }
  // },
};
</script>
